// TODO
// 색상 + 뒤에 standard 등 텍스트 유무에 따른 아이콘 네이밍 정리 필요
export { default as BigSalePromotionCouponIcon } from './big_sale_promotion_coupon.svg';
export { default as BigSaleTextIcon } from './big_sale_text.svg';
export { default as MembershipStandard16x16Icon } from './ic__membership_standard__16x16.svg';
export { default as MembershipStandard22x12Icon } from './ic__membership_standard__22x12.svg';
export { default as BonuspackClovercon } from './ic_clover.svg';
export { default as BonuspackCloverFillIcon } from './ic_clover_fill.svg';
export { default as BonuspackCloverFill18x18Icon } from './ic_clover_fill_18x18.svg';
export { default as MembershipStandard16x8Icon } from './ic_membership_standard_16x8.svg';
export { default as MembershipStandard24x12Icon } from './ic_membership_standard_24x12.svg';
export { default as MembershipStandard28x14Icon } from './ic_membership_standard_28x14.svg';
export { default as MembershipStandardWithWhiteText98x16Icon } from './ic_membership_standard_white_text98x16.svg';
export { default as MembershipLogoIcon } from './logo__none__membership.svg';
export { default as MembershipStandard86x14Icon } from './membership_standard_icon_86x14.svg';
export { default as MembershipStandardWithGreenText98x16Icon } from './membership_standard_icon_98x16.svg';
export { default as MembershipWhiteAndGreen28x14Icon } from './white_green_membership_icon_28x14.svg';
